import { useQuery, useQueryClient } from '@tanstack/react-query';

import * as ApiShowroom from '@Api/Showroom';
import { useDeps } from '@Contexts/DI';
import { useRequest } from '@Contexts/Request';

import type { UseQueryResult } from '@tanstack/react-query';
import type { SellPointDataSearch, SellPointsParams } from '@Types/SellPointsSearch';

function useSellPointsSearch({
  params,
  pickupPoint,
}: SellPointsParams): UseQueryResult<SellPointDataSearch[]> {
  const { logger } = useDeps();
  const { country, language } = useRequest();
  const queryClient = useQueryClient();
  const keys = ['sell-points-list', { country, lang: language.id, params, pickupPoint }];

  const result = useQuery({
    queryKey: keys,
    queryFn: async () => {
      const cache = queryClient.getQueryData<SellPointDataSearch[]>(keys);

      if (cache) return Promise.resolve(cache);
      try {
        const sellPoints = await ApiShowroom.getSellPointsSearch({ params, pickupPoint });

        return sellPoints;
      } catch (err) {
        logger.log(err);
        return Promise.resolve(null);
      }
    },
    enabled: true,
    placeholderData: (previousData) => previousData,
  });

  return result;
}

export default useSellPointsSearch;
